import register from '@kpsys/angularjs-register';
import {sutorReportReferencesRoutes} from 'src/features/sutor/pages/reports/report-references-page/lib/sutor-report-references.routes';
import {SutorHomePageService} from 'src/features/sutor/pages/homepage/services/sutor-home-page.service';
import {SutorHomePageDataService} from 'src/features/sutor/pages/homepage/services/sutor-home-page.data-service';
import {SutorReportReferencesDataService} from 'src/features/sutor/pages/reports/report-references-page/lib/sutor-report-references.data-service';
import {SutorReportReferencesService} from 'src/features/sutor/pages/reports/report-references-page/lib/sutor-report-references.service';
import {sutorReportsProcessingRoutes} from './pages/reports/reports-processing-page/lib/sutor-reports-processing.routes';
import {SutorReportsProcessingService} from './pages/reports/reports-processing-page/lib/sutor-reports-processing.service';
import {SutorReportsApprovingService} from './pages/reports/reports-approving-page/lib/sutor-reports-approving.service';
import {sutorReportsApprovingRoutes} from './pages/reports/reports-approving-page/lib/sutor-reports-approving.routes';
import {AttendanceCalendarDataService} from './components/attendance-calendar/attendance-calendar.data-service';
import {AttendanceCalendarService} from './components/attendance-calendar/attendance-calendar.service';
import {TabbedSubpagesUrlManagementService} from 'src/features/erp/components/erp-tabbed-subpages/tabbed-subpages-url-management.service';
import {SutorReportsOptimisationService} from 'src/features/sutor/pages/record-detail/tab-pages/reports-optimisation-tab/sutor-reports-optimisation.service';
import {sutorProjectsRoutes} from 'src/features/sutor/pages/projects/sutor-projects.routes';
import {employeesRoutes} from 'src/features/sutor/pages/employees/employees.routes';

export default register('portaro.features.sutor', ['ui.router'])
    // Tabbed subpages URL management
    .service(TabbedSubpagesUrlManagementService.serviceName, TabbedSubpagesUrlManagementService)

    // Work attendance calendar
    .service(AttendanceCalendarDataService.serviceName, AttendanceCalendarDataService)
    .service(AttendanceCalendarService.serviceName, AttendanceCalendarService)

    // Projects
    .config(sutorProjectsRoutes)

    // Employees
    .config(employeesRoutes)

    // Landing
    .service(SutorHomePageDataService.serviceName, SutorHomePageDataService)
    .service(SutorHomePageService.serviceName, SutorHomePageService)

    // Reports (references page)
    .config(sutorReportReferencesRoutes)
    .service(SutorReportReferencesDataService.serviceName, SutorReportReferencesDataService)
    .service(SutorReportReferencesService.serviceName, SutorReportReferencesService)
    // Reports processing
    .config(sutorReportsProcessingRoutes)
    .service(SutorReportsProcessingService.serviceName, SutorReportsProcessingService)
    // Reports approving
    .config(sutorReportsApprovingRoutes)
    .service(SutorReportsApprovingService.serviceName, SutorReportsApprovingService)
    // Reports finalisation
    .service(SutorReportsOptimisationService.serviceName, SutorReportsOptimisationService)

    .name();